// extracted by mini-css-extract-plugin
export default {"Settings":"styles_Settings__rCF3d"};